export default __webpack_public_path__ + "central_help.jpg";